import actionTypes from '../constants/action-types';

const forceReloadView = () => ({
  type: actionTypes.FORCE_RELOAD_VIEW,
});

export default forceReloadView;
